import { NavLink } from 'react-router'

export interface Club {
  id: number
  name: string
}

export default function ClubListItem({ club }: { club: Club }) {
  return (
    <li className="flex justify-between gap-x-6 py-5">
      <NavLink className="flex justify-between w-full" to={`/club/${club.id}`}>
        <div className="flex min-w-0 gap-x-4">
          <div className="min-w-0 flex-auto">
            <p className="font-semibold leading-6 text-gray-900">{club.name}</p>
            {/* TODO: Add club address */}
            {/* <p className="mt-1 truncate text-xs leading-5 text-gray-500">123 Test Street, Richardson, TX, 75081</p> */}
          </div>
        </div>
        <div className="shrink-0 sm:flex sm:flex-col sm:items-end flex">
          <button className="disabled:opacity-50 disabled:hover:cursor-not-allowed inline-flex items-center gap-x-2 rounded-md bg-indigo-600 px-6 py-2.5 text-sm font-semibold text-white shadow-sm enabled:hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
            →
          </button>
        </div>
      </NavLink>
    </li>
  )
}
